import translate from '../i18n/config';
import { Modules, AuthRoutes, PermissionActionsEnum, PermissionModulesEnum } from '../enums';
import { Menu } from '../interfaces/common';
import { getCurrentMonthAndYear } from './methods';

export const TABLE_CONSTANTS = {
  defaultPerPage: 10,
  noRecordsFound: translate.t('common.table.noRecordsFound'),
};

export const Regex = {
  email:
    /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i,
  password: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[\d])(?=.*[^A-Za-z0-9\s])\S{6,15}$/,
  floatValues: /^\d+(\.\d{1,2})?$/,
  floatWithNegative: /^-?\d+(\.\d{1,2})?$/,
  percentPattern: /^(?:\d{1,2}(?:\.\d{1,2})?|100(?:\.0{1,2})?)$/,
  website:
    /^(https?:\/\/)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)$/,
  phone: /^[+]?\d{1,16}$/,};

export const MenuTextMapping = {
  dashboard: 'dashboard',
  users: 'users',
  properties: 'properties',
  developers: 'developers',
  logout: 'logout',
  blank: '',
};

export const RoutesMapping = {
  [MenuTextMapping.dashboard]: [AuthRoutes.dashboard],
  [MenuTextMapping.users]: [AuthRoutes.users],
  [MenuTextMapping.developers]: [AuthRoutes.developers],
  [MenuTextMapping.properties]: [AuthRoutes.properties],
};

export const ROUTES_PERMISSIONS_BINDING = {
  users: [
    {
      [PermissionModulesEnum.Users]: [
        PermissionActionsEnum.View,
        PermissionActionsEnum.Add,
        PermissionActionsEnum.Update,
        PermissionActionsEnum.Delete,
      ],
    },
  ],
  properties: [
    {
      [PermissionModulesEnum.Properties]: [
        PermissionActionsEnum.View,
        PermissionActionsEnum.Add,
        PermissionActionsEnum.Update,
        PermissionActionsEnum.Delete,
      ],
    },
  ],
  developers: [
    {
      [PermissionModulesEnum.Developers]: [
        PermissionActionsEnum.View,
        PermissionActionsEnum.Add,
        PermissionActionsEnum.Update,
        PermissionActionsEnum.Delete,
      ],
    },
  ],
};

export const Menus: Menu[] = [
  {
    text: translate.t('layout.pageTexts.menus.dashboard'),
    id: MenuTextMapping.dashboard,
    redirectsTo: Modules.home + AuthRoutes.dashboard,
    icon: <i className="menu-icon tf-icons ri-home-smile-line"></i>,
  },
  {
    text: translate.t('layout.pageTexts.menus.resources.users'),
    id: MenuTextMapping.users,
    redirectsTo: Modules.users + AuthRoutes.users,
    icon: <i className="menu-icon tf-icons ri-user-line"></i>,
    accessibleTo: ROUTES_PERMISSIONS_BINDING.users,
  },
  {
    text: translate.t('layout.pageTexts.menus.developers'),
    id: MenuTextMapping.developers,
    redirectsTo: Modules.developers + AuthRoutes.developers,
    icon: <i className="menu-icon tf-icons ri-building-2-line"></i>,
    accessibleTo: ROUTES_PERMISSIONS_BINDING.developers,
  },
  {
    text: translate.t('layout.pageTexts.menus.properties'),
    id: MenuTextMapping.properties,
    redirectsTo: Modules.properties + AuthRoutes.properties,
    icon: <i className="menu-icon tf-icons ri-building-line"></i>,
    accessibleTo: ROUTES_PERMISSIONS_BINDING.properties,
  },
];

export const VALIDATION_FIELD_MAPPING = {
  username: 'username',
  first_name: 'first_name',
  password: 'password',
  email: 'email',
  oldPassword: 'oldPassword',
  newPassword: 'newPassword',
  confirmPassword: 'confirmPassword',
  role: 'role',
  manager: 'manager',
  updated_at: 'updated_at',
  actions: 'actions',
  searchText: 'searchText',
  changed_at: 'changed_at',
  changer_name: 'changer_name',
  field_name: 'field_name',
  old_value: 'old_value',
  new_value: 'new_value',
  firstName: 'firstName',
  lastName: 'lastName',
  phoneNumber: 'phoneNumber',
  phone: 'phone',
  countryCode: 'countryCode',
  order_by: 'order_by',
  name: 'name',
  address: 'address',
  status: 'status',
  currentPassword: 'currentPassword',
  vendorId: 'vendorId',
  updatedAt: 'updatedAt',
  serviceType: 'serviceTypeId',
  addressCity: 'addressCity',
  addressState: 'addressState',
  addressPostcode: 'addressPostcode',
  addressCountry: 'addressCountry',
  serviceRate: 'serviceRate',
  area: 'area',
  areaUserIds: 'areaUserIds',
  notes: 'notes',
  title: 'title',
  description: 'description',
  priority: 'priority',
  due_date: 'due_date',
  displayName: 'displayName',
  profileImage: 'profileImage',
  isSystemUser: 'isSystemUser',
  cityId: 'cityId',
  stateId: 'stateId',
  countryId: 'countryId',
  companyName: 'companyName',
  companyContactNumber: 'companyContactNumber',
  companyCountryCode: 'companyCountryCode',
  companyLogo: 'companyLogo',
  companyAddressLine1: 'companyAddressLine1',
  companyAddressLine2: 'companyAddressLine2',
  companyCityId: 'companyCityId',
  companyStateId: 'companyStateId',
  companyCountryId: 'companyCountryId',
  companyPincode: 'companyPincode',
  alias_name: 'alias_name',
  primary_owner_name: 'primary_owner_name',
  gst_number: 'gst_number',
  code: 'code',
  website: 'website',
  office_address_1: 'office_address_1',
  office_address_2: 'office_address_2',
  area_id: 'area_id',
  pincode: 'pincode',
  logo: 'logo',
  note: 'notes',
  addressLine1: 'addressLine1',
  addressLine2: 'addressLine2',
  userPincode: 'pincode',
  profileImageFile: 'profileImageFile',
  logoFile: 'logoFile',
  companyLogoFile: 'companyLogoFile',
  reraId: 'reraId',
  property_developer_name: 'property_developer_name',
  category: 'category',
  categoryId: 'categoryId',
  rera_number: 'rera_number',
  launch_date: 'launch_date',
  possession_date: 'possession_date',
  construction_status: 'construction_status',
  amenities: 'amenities',
  latitude: 'latitude',
  longitude: 'longitude',
  contact_person: 'contact_person',
  contact_number: 'contact_number',
  contact_email: 'contact_email',
  is_primary: 'is_primary',
  total_blocks: 'total_blocks',
  total_flats: 'total_flats',
  total_shops: 'total_shops',
  property_type_id: 'property_type_id',
  bhk_type: 'bhk_type',
  price: 'price',
  rera_area: 'rera_area',
  super_built_up_area: 'super_built_up_area',
  total_units: 'total_units',
  developer_property: 'developer_property',
  developer: 'developer',
  constructionStatus: 'constructionStatus',
  developerId: 'developerId',
  gallery: 'gallery',
  brochure: 'brochure',
  documents: 'documents',
  whatsapp_number: 'whatsapp_number',
  approval_status: 'approval_status',
};

export const HEAD_CELL_SORT_DISABLED = {
  userList: [
    VALIDATION_FIELD_MAPPING.actions,
    VALIDATION_FIELD_MAPPING.manager,
    VALIDATION_FIELD_MAPPING.role,
  ],

  developerList: [
    VALIDATION_FIELD_MAPPING.actions,
    VALIDATION_FIELD_MAPPING.addressCity,
    VALIDATION_FIELD_MAPPING.phoneNumber,
  ],
  propertyList: [
    VALIDATION_FIELD_MAPPING.actions,
    VALIDATION_FIELD_MAPPING.status,
    VALIDATION_FIELD_MAPPING.addressCity,
    VALIDATION_FIELD_MAPPING.contact_person,
  ],
};

export const HEAD_CELL_LABELS_MAPPING = {
  userList: {
    [VALIDATION_FIELD_MAPPING.first_name]: translate.t('users.list.pageTexts.table.columns.user'),
    [VALIDATION_FIELD_MAPPING.phoneNumber]: translate.t('users.list.pageTexts.table.columns.phone'),
    [VALIDATION_FIELD_MAPPING.companyName]: translate.t('users.list.pageTexts.table.columns.company'),
    [VALIDATION_FIELD_MAPPING.role]: translate.t('users.list.pageTexts.table.columns.role'),
    [VALIDATION_FIELD_MAPPING.manager]: translate.t('users.list.pageTexts.table.columns.manager'),
    [VALIDATION_FIELD_MAPPING.status]: translate.t('users.list.pageTexts.table.columns.status'),
    [VALIDATION_FIELD_MAPPING.actions]: translate.t('users.list.pageTexts.table.columns.actions'),
  },
  developerList: {
    [VALIDATION_FIELD_MAPPING.name]: translate.t('developers.list.pageTexts.table.columns.name'),
    [VALIDATION_FIELD_MAPPING.email]: translate.t('developers.list.pageTexts.table.columns.email'),
    [VALIDATION_FIELD_MAPPING.phoneNumber]: translate.t('developers.list.pageTexts.table.columns.phoneNumber'),
    [VALIDATION_FIELD_MAPPING.area_id]: translate.t('developers.list.pageTexts.table.columns.area'),
    [VALIDATION_FIELD_MAPPING.addressCity]: translate.t('developers.list.pageTexts.table.columns.city'),
    [VALIDATION_FIELD_MAPPING.addressState]: translate.t('developers.list.pageTexts.table.columns.state'),
    [VALIDATION_FIELD_MAPPING.addressCountry]: translate.t('developers.list.pageTexts.table.columns.country'),
    [VALIDATION_FIELD_MAPPING.status]: translate.t('developers.list.pageTexts.table.columns.status'),
    [VALIDATION_FIELD_MAPPING.actions]: translate.t('developers.list.pageTexts.table.columns.actions'),
  },
  propertyList: {
    [VALIDATION_FIELD_MAPPING.name]: translate.t('properties.list.pageTexts.table.columns.name'),
    [VALIDATION_FIELD_MAPPING.rera_number]: translate.t('properties.list.pageTexts.table.columns.reraNumber'),
    [VALIDATION_FIELD_MAPPING.addressCity]: translate.t('properties.list.pageTexts.table.columns.location'),
    [VALIDATION_FIELD_MAPPING.property_developer_name]: translate.t('properties.list.pageTexts.table.columns.developer'),
    [VALIDATION_FIELD_MAPPING.category]: translate.t('properties.list.pageTexts.table.columns.category'),
    [VALIDATION_FIELD_MAPPING.construction_status]: translate.t('properties.list.pageTexts.table.columns.status'),
    [VALIDATION_FIELD_MAPPING.contact_person]: translate.t('properties.list.pageTexts.table.columns.contactPerson'),
    [VALIDATION_FIELD_MAPPING.approval_status]: translate.t('properties.list.pageTexts.table.columns.approvalStatus'),
    [VALIDATION_FIELD_MAPPING.status]: translate.t('properties.list.pageTexts.table.columns.isActive'),
    [VALIDATION_FIELD_MAPPING.actions]: translate.t('properties.list.pageTexts.table.columns.actions'),
  },
};

export const HEAD_CELL_SORT_MAPPING = {
  userList: {
    [VALIDATION_FIELD_MAPPING.status]: 'is_active',
    [VALIDATION_FIELD_MAPPING.phoneNumber]: 'phone',
    [VALIDATION_FIELD_MAPPING.companyName]: 'company_name',
  },
  developerList: {
    [VALIDATION_FIELD_MAPPING.name]: 'name',
    [VALIDATION_FIELD_MAPPING.email]: 'email',
    [VALIDATION_FIELD_MAPPING.phoneNumber]: 'phone',
    [VALIDATION_FIELD_MAPPING.addressCity]: 'city_id',
    [VALIDATION_FIELD_MAPPING.addressState]: 'state_id',
    [VALIDATION_FIELD_MAPPING.addressCountry]: 'country_id',
    [VALIDATION_FIELD_MAPPING.status]: 'is_active',
  },
  propertyList: {
    [VALIDATION_FIELD_MAPPING.name]: 'name',
    [VALIDATION_FIELD_MAPPING.rera_number]: 'rera_number',
    [VALIDATION_FIELD_MAPPING.addressCity]: 'city',
    [VALIDATION_FIELD_MAPPING.property_developer_name]: 'property_developer_name',
    [VALIDATION_FIELD_MAPPING.category]: 'category',
    [VALIDATION_FIELD_MAPPING.construction_status]: 'construction_status',
    [VALIDATION_FIELD_MAPPING.contact_person]: 'contact_person',
    [VALIDATION_FIELD_MAPPING.status]: 'is_active',
  },
};

export const HEAD_CELL_WIDTH_MAPPING = {
  userList: {
    [VALIDATION_FIELD_MAPPING.first_name]: '25%',
    [VALIDATION_FIELD_MAPPING.phoneNumber]: '15%',
    [VALIDATION_FIELD_MAPPING.companyName]: '20%',
    [VALIDATION_FIELD_MAPPING.role]: '10%',
    [VALIDATION_FIELD_MAPPING.manager]: '10%',
    [VALIDATION_FIELD_MAPPING.status]: '10%',
    [VALIDATION_FIELD_MAPPING.actions]: '10%',
  },
  developerList: {
      [VALIDATION_FIELD_MAPPING.name]: '20%',
      [VALIDATION_FIELD_MAPPING.email]: '15%',
      [VALIDATION_FIELD_MAPPING.phoneNumber]: '10%',
      [VALIDATION_FIELD_MAPPING.area_id]: '10%',
      [VALIDATION_FIELD_MAPPING.addressCity]: '10%',
      [VALIDATION_FIELD_MAPPING.addressState]: '10%',
      [VALIDATION_FIELD_MAPPING.addressCountry]: '10%',
      [VALIDATION_FIELD_MAPPING.status]: '5%',
      [VALIDATION_FIELD_MAPPING.actions]: '10%',
  },
  propertyList: {
      [VALIDATION_FIELD_MAPPING.name]: '10%',
      [VALIDATION_FIELD_MAPPING.rera_number]: '10%',
      [VALIDATION_FIELD_MAPPING.addressCity]: '15%',
      [VALIDATION_FIELD_MAPPING.property_developer_name]: '10%',
      [VALIDATION_FIELD_MAPPING.category]: '10%',
      [VALIDATION_FIELD_MAPPING.construction_status]: '10%',
      [VALIDATION_FIELD_MAPPING.contact_person]: '15%',
      [VALIDATION_FIELD_MAPPING.approval_status]: '10%',
      [VALIDATION_FIELD_MAPPING.status]: '5%',
      [VALIDATION_FIELD_MAPPING.actions]: '10%',
  },
};

export const APP_ERROR_MESSAGES = {
  login: {
    blankUsername: translate.t('login.pageTexts.form.username.errors.required'),
    invalidUsername: translate.t('login.pageTexts.form.username.errors.invalid'),
    blankPhoneNumber: translate.t('login.pageTexts.form.phoneNumber.errors.required'),
    invalidPhoneNumber: translate.t('login.pageTexts.form.phoneNumber.errors.invalid'),
    blankPassword: translate.t('login.pageTexts.form.password.errors.required'),
    shortPassword: translate.t('login.pageTexts.form.password.errors.lengthShort'),
    longPassword: translate.t('login.pageTexts.form.password.errors.lengthLong'),
  },
  common: {
    invalidEmail: translate.t('common.errors.invalidEmail'),
    maxDigits: translate.t('common.errors.maxDigits'),
    invalidUrl: translate.t('common.errors.invalidUrl'),
    dropdown: {
      notSelected: translate.t('common.dropdown.notSelected'),
    },
  },
  developers: {
    addEdit: {
      blankName: translate.t('developers.addEdit.pageTexts.form.name.errors.required'),
    },
  },
  forgotPassword: {
    blankEmail: translate.t('forgotPassword.pageTexts.form.email.errorMessage'),
  },
  resetPassword: {
    blankNewPassword: translate.t('resetPassword.pageTexts.form.newPassword.errors.required'),
    mismatchNewPassword: translate.t('resetPassword.pageTexts.form.newPassword.errors.mismatch'),
    blankConfirmPassword: translate.t(
      'resetPassword.pageTexts.form.confirmPassword.errors.required'
    ),
    mismatchConfirmPassword: translate.t(
      'resetPassword.pageTexts.form.confirmPassword.errors.mismatch'
    ),
    passwordFormat: translate.t('resetPassword.pageTexts.form.newPassword.errors.passwordFormat'),
  },
  users: {
    addEdit: {
      blankFirstName: translate.t('users.addEdit.pageTexts.form.firstName.errors.required'),
      blankLastName: translate.t('users.addEdit.pageTexts.form.lastName.errors.required'),
      blankEmail: translate.t('users.addEdit.pageTexts.form.email.errors.required'),
      invalidEmail: translate.t('users.addEdit.pageTexts.form.email.errors.invalid'),
      blankPhoneNumber: translate.t('users.addEdit.pageTexts.form.phoneNumber.errors.required'),
      blankRole: translate.t('users.addEdit.pageTexts.form.role.errors.required'),
      blankCompanyName: translate.t('users.addEdit.pageTexts.form.companyName.errors.required'),
      blankCompanyContactNumber: translate.t(
        'users.addEdit.pageTexts.form.companyContactNumber.errors.required'
      ),
      blankCompanyAddressLine1: translate.t(
        'users.addEdit.pageTexts.form.companyAddressLine1.errors.required'
      ),
      blankCompanyCity: translate.t('users.addEdit.pageTexts.form.companyCity.errors.required'),
      blankCompanyState: translate.t('users.addEdit.pageTexts.form.companyState.errors.required'),
      blankCompanyCountry: translate.t(
        'users.addEdit.pageTexts.form.companyCountry.errors.required'
      ),
      invalidProfileImage: translate.t('users.addEdit.pageTexts.form.profileImage.errors.invalid'),
      blankCountry: translate.t('users.addEdit.pageTexts.form.country.errors.required'),
      blankState: translate.t('users.addEdit.pageTexts.form.state.errors.required'),
      blankCity: translate.t('users.addEdit.pageTexts.form.city.errors.required'),
      blankArea: translate.t('users.addEdit.pageTexts.form.area.errors.required'),
    },
    changePassword: {
      blankCurrentPassword: translate.t(
        'changePassword.pageTexts.form.currentPassword.errors.required'
      ),
      blankNewPassword: translate.t('changePassword.pageTexts.form.newPassword.errors.required'),
      passwordFormat: translate.t(
        'changePassword.pageTexts.form.newPassword.errors.passwordFormat'
      ),
      blankConfirmPassword: translate.t(
        'changePassword.pageTexts.form.confirmPassword.errors.required'
      ),
      passwordsDoNotMatch: translate.t(
        'changePassword.pageTexts.form.confirmPassword.errors.mismatch'
      ),
    },
  },

  customers: {
    addEdit: {
      blankCustomerName: translate.t('customers.addEdit.pageTexts.form.customer.errors.required'),
      blankPrimaryFirstName: translate.t(
        'customers.addEdit.pageTexts.form.primaryFirstName.errors.required'
      ),
      blankPrimaryLastName: translate.t(
        'customers.addEdit.pageTexts.form.primaryLastName.errors.required'
      ),
      blankPrimaryEmail: translate.t(
        'customers.addEdit.pageTexts.form.primaryEmail.errors.required'
      ),
      invalidPrimaryEmail: translate.t(
        'customers.addEdit.pageTexts.form.primaryEmail.errors.invalid'
      ),
      invalidSecondaryEmail: translate.t(
        'customers.addEdit.pageTexts.form.secondaryEmail.errors.invalid'
      ),
      blankCountryCode: translate.t('customers.addEdit.pageTexts.form.countryCode.errors.required'),
      blankDisplayName: translate.t('customers.addEdit.pageTexts.form.displayName.errors.required'),
      blankBillingCurrency: translate.t(
        'customers.addEdit.pageTexts.form.billingCurrency.errors.required'
      ),
      blankPhoneNumber: translate.t('customers.addEdit.pageTexts.form.phoneNumber.errors.required'),
      maxLengthExceeded: translate.t('common.maxLength.errors.exceeded'),
    },
  },
  properties: {
    addEdit: {
      blankCustomer: translate.t('properties.addEdit.pageTexts.form.customer.errors.required'),
      blankPropertyName: translate.t('properties.addEdit.pageTexts.form.name.errors.required'),
      blankPublicName: translate.t('properties.addEdit.pageTexts.form.publicName.errors.required'),
      blankLatitude: translate.t('properties.addEdit.pageTexts.form.latitude.errors.required'),
      invalidLatitude: translate.t('properties.addEdit.pageTexts.form.latitude.errors.invalid'),
      blankLongitude: translate.t('properties.addEdit.pageTexts.form.longitude.errors.required'),
      invalidLongitude: translate.t('properties.addEdit.pageTexts.form.longitude.errors.invalid'),
      blankHospitableId: translate.t(
        'properties.addEdit.pageTexts.form.hospitableId.errors.required'
      ),
      invalidPictureUrl: translate.t('properties.addEdit.pageTexts.form.pictureUrl.errors.invalid'),
      blankManagedBy: translate.t('properties.addEdit.pageTexts.form.managedBy.errors.required'),
      blankCleaningManagedBy: translate.t(
        'properties.addEdit.pageTexts.form.cleaningManagedBy.errors.required'
      ),
      blankWhoCollectsMoney: translate.t(
        'properties.addEdit.pageTexts.form.whoCollectsMoney.errors.required'
      ),
      blankWhoCollectsHst: translate.t(
        'properties.addEdit.pageTexts.form.whoCollectsHst.errors.required'
      ),
      blankAddress: translate.t('properties.addEdit.pageTexts.form.address1.errors.required'),
      blankCity: translate.t('properties.addEdit.pageTexts.form.city.errors.required'),
      blankState: translate.t('properties.addEdit.pageTexts.form.state.errors.required'),
      blankPostcode: translate.t('properties.addEdit.pageTexts.form.postal.errors.required'),
      blankCountry: translate.t('properties.addEdit.pageTexts.form.country.errors.required'),
      blankArea: translate.t('properties.addEdit.pageTexts.form.areaId.errors.required'),
      blankNearbyArea: translate.t('properties.addEdit.pageTexts.form.area.errors.required'),
      blankBookingType: translate.t('properties.addEdit.pageTexts.form.bookingType.errors.required'),
      blankCommissionPercentage: translate.t(
        'properties.addEdit.pageTexts.form.commission.errors.required'
      ),
      blankMaintenanceDetails: translate.t(
        'properties.addEdit.pageTexts.form.maintenanceDetails.errors.required'
      ),
      invalidCommissionPercentage: translate.t(
        'properties.addEdit.pageTexts.form.commission.errors.invalid'
      ),
      blankDescription: translate.t('properties.addEdit.pageTexts.form.description.errors.required'),
      maxLengthExceeded: translate.t('common.maxLength.errors.exceeded'),
      invalidLaunchDate: translate.t('properties.addEdit.pageTexts.form.launchDate.errors.invalid'),
      blankContactDetails: translate.t('properties.addEdit.pageTexts.form.contactDetails.errors.required'),
      blankInventoryDetails: translate.t('properties.addEdit.pageTexts.form.inventoryDetails.errors.required'),
      blankWhatsAppDescription: translate.t('properties.addEdit.pageTexts.form.whatsappDescription.errors.required'),
      invalidPhoneNumber: translate.t('common.errors.invalidPhoneNumber'),
      // Granular Contact Details Errors
      blankContactPerson: translate.t('properties.addEdit.pageTexts.form.contactDetails.errors.contactPersonRequired'),
      blankContactNumber: translate.t('properties.addEdit.pageTexts.form.contactDetails.errors.contactNumberRequired'),
      blankEmail: translate.t('properties.addEdit.pageTexts.form.contactDetails.errors.emailRequired'),
      contactPrimaryRequired: translate.t('properties.addEdit.pageTexts.form.contactDetails.errors.primaryRequired'),
      // Granular Inventory Details Errors
      blankPropertyType: translate.t('properties.addEdit.pageTexts.form.inventoryDetails.errors.propertyTypeRequired'),
      blankBhkType: translate.t('properties.addEdit.pageTexts.form.inventoryDetails.errors.bhkTypeRequired'),
      blankPrice: translate.t('properties.addEdit.pageTexts.form.inventoryDetails.errors.priceRequired'),
      blankReraArea: translate.t('properties.addEdit.pageTexts.form.inventoryDetails.errors.reraAreaRequired'),
      measurementRequired: translate.t('properties.addEdit.pageTexts.form.inventoryDetails.errors.measurementRequired'),
      invalidReraArea: translate.t('properties.addEdit.pageTexts.form.inventoryDetails.errors.invalidReraArea'),
      blankTotalUnits: translate.t('properties.addEdit.pageTexts.form.inventoryDetails.errors.totalUnitsRequired'),
      blankApprovalStatus: translate.t('properties.addEdit.pageTexts.form.approvalStatus.errors.required'),
    },
  },
  transactions: {
    addEdit: {
      blankTransactionDate: translate.t(
        'transactions.addEdit.pageTexts.form.transactionDate.errors.required'
      ),
      blankProperty: translate.t('transactions.addEdit.pageTexts.form.property.errors.required'),
      blankDebitCredit: translate.t(
        'transactions.addEdit.pageTexts.form.debitCredit.errors.required'
      ),
      blankTransactionType: translate.t(
        'transactions.addEdit.pageTexts.form.transactionType.errors.required'
      ),
      blankReviewedBy: translate.t(
        'transactions.addEdit.pageTexts.form.reviewedBy.errors.required'
      ),
      invalidActualCost: translate.t(
        'transactions.addEdit.pageTexts.form.actualCost.errors.invalid'
      ),
      blankTotalAmount: translate.t(
        'transactions.addEdit.pageTexts.form.totalAmount.errors.required'
      ),
      invalidTotalAmount: translate.t(
        'transactions.addEdit.pageTexts.form.totalAmount.errors.invalid'
      ),
      blankSubTotal: translate.t('transactions.addEdit.pageTexts.form.subTotal.errors.required'),
      invalidSubTotal: translate.t('transactions.addEdit.pageTexts.form.subTotal.errors.invalid'),
      maxLengthExceeded: translate.t('common.maxLength.errors.exceeded'),
    },
  },
  reservations: {
    edit: {
      blankCheckInDate: translate.t('reservations.edit.pageTexts.form.checkInDate.errors.required'),
      blankCheckOutDate: translate.t(
        'reservations.edit.pageTexts.form.checkOutDate.errors.required'
      ),
      blankReviewedBy: translate.t('reservations.edit.pageTexts.form.reviewedBy.errors.required'),
      invalidXNightRoomFees: translate.t(
        'reservations.edit.pageTexts.form.xNightRoomFees.errors.invalid'
      ),
      invalidPerNightFees: translate.t(
        'reservations.edit.pageTexts.form.perNightFees.errors.invalid'
      ),
      invalidCleaningFees: translate.t(
        'reservations.edit.pageTexts.form.cleaningFees.errors.invalid'
      ),
      invalidLinenFees: translate.t('reservations.edit.pageTexts.form.linenFees.errors.invalid'),
      invalidPetFees: translate.t('reservations.edit.pageTexts.form.petFees.errors.invalid'),
      invalidHostFees: translate.t('reservations.edit.pageTexts.form.hostFees.errors.invalid'),
      invalidDiscount: translate.t('reservations.edit.pageTexts.form.discount.errors.invalid'),
      invalidMatTax: translate.t('reservations.edit.pageTexts.form.matTax.errors.invalid'),
      invalidHstTax: translate.t('reservations.edit.pageTexts.form.hstTax.errors.invalid'),
      invalidAdjustments: translate.t(
        'reservations.edit.pageTexts.form.adjustments.errors.invalid'
      ),
      invalidHostPayout: translate.t('reservations.edit.pageTexts.form.hostPayout.errors.invalid'),
      invalidActualRevenue: translate.t(
        'reservations.edit.pageTexts.form.actualRevenue.errors.invalid'
      ),
      maxLengthExceeded: translate.t('common.maxLength.errors.exceeded'),
    },
  },
  invoices: {
    addList: {
      blankProperty: translate.t('invoices.addList.pageTexts.form.property.errors.required'),
      blankMonth: translate.t('invoices.addList.pageTexts.form.month.errors.required'),
      blankYear: translate.t('invoices.addList.pageTexts.form.year.errors.required'),
    },
    editPreviewPayment: {
      blankDate: translate.t(
        'invoices.editPreviewPayment.pageTexts.form.paymentsTab.modal.addPayment.fields.date.errors.required'
      ),
      blankAmount: translate.t(
        'invoices.editPreviewPayment.pageTexts.form.paymentsTab.modal.addPayment.fields.amount.errors.required'
      ),
      invalidAmount: translate.t(
        'invoices.editPreviewPayment.pageTexts.form.paymentsTab.modal.addPayment.fields.amount.errors.invalid'
      ),
      blankMethod: translate.t(
        'invoices.editPreviewPayment.pageTexts.form.paymentsTab.modal.addPayment.fields.method.errors.required'
      ),
      blankAccount: translate.t(
        'invoices.editPreviewPayment.pageTexts.form.paymentsTab.modal.addPayment.fields.account.errors.required'
      ),
      blankNotes: translate.t(
        'invoices.editPreviewPayment.pageTexts.form.paymentsTab.modal.addPayment.fields.notes.errors.required'
      ),
      blankReviewedBy: translate.t(
        'invoices.editPreviewPayment.pageTexts.form.detailsTab.otherDetails.reviewedBy.errors.required'
      ),
    },
  },
};

export const APP_SUCCESS_MESSAGES = {
  userCreated: translate.t('users.addEdit.pageTexts.form.addSuccess'),
  userUpdated: translate.t('users.addEdit.pageTexts.form.editSuccess'),

  vendorCreated: translate.t('vendor.addEdit.pageTexts.form.addSuccess'),
  vendorUpdated: translate.t('vendor.addEdit.pageTexts.form.editSuccess'),
  customerCreated: translate.t('customers.addEdit.pageTexts.form.addSuccess'),
  customerUpdated: translate.t('customers.addEdit.pageTexts.form.editSuccess'),
  propertyCreated: translate.t('properties.addEdit.pageTexts.form.addSuccess'),
  propertyUpdated: translate.t('properties.addEdit.pageTexts.form.editSuccess'),
  propertySyncQueued: translate.t('properties.list.pageTexts.syncModal.successMessage'),
  transactionCreated: translate.t('transactions.addEdit.pageTexts.form.addSuccess'),
  transactionUpdated: translate.t('transactions.addEdit.pageTexts.form.editSuccess'),
  reservationUpdated: translate.t('reservations.edit.pageTexts.form.editSuccess'),
  invoiceDetailsUpdated: translate.t(
    'invoices.editPreviewPayment.pageTexts.form.detailsTab.editSuccess'
  ),
  syncReservationDispatched: translate.t('reservations.list.pageTexts.syncDispatchedSuccess'),
  changePassword: translate.t('changePassword.pageTexts.form.success'),
  forgotPassword: translate.t('forgotPassword.pageTexts.form.success'),
  resetPassword: translate.t('resetPassword.pageTexts.form.success'),
  propertyAssigned: translate.t('users.addEdit.pageTexts.form.propertyAssignSuccess'),
  userAssigned: translate.t('properties.addEdit.pageTexts.form.userAssignSuccess'),
  invoiceCreated: translate.t('invoices.addList.pageTexts.form.addSuccess'),
};

export const MaxLength = {
  login: {
    password: 15,
  },
  pageSize: 200,
  common: 100,
  pictureUrl: 250,
};

export const MinLength = {
  login: {
    password: 6,
  },
};

export const LOCAL_STORAGE_KEYS: any = {
  loggedInUser: 'loggedInUser',
  token: 'token',
  theme: 'theme',
  permissions: 'permissions',
  isSystemAdmin: 'isSystemAdmin',
  exception: 'exception',
  loading: 'loading',
};

export const GENERIC_LOOKUP_KEYS = {
  status: 'status',
  salutation: 'salutation',
  billingCurrency: 'billing_currency',
  propertyBookingType: 'property_booking_type',
  whoCollectsMoney: 'who_collects_money',
  whoCollectsHst: 'who_collects_hst',
  transactionType: 'transaction_type',
  debitCredit: 'crdr',
  hstPercentage: 'tax',
  transactionStatus: 'transaction_status',
  crdr: 'crdr',
  reservationStatus: 'reservation_status',
  invoiceStatus: 'invoice_status',
  source: 'source',
  linkedWithHospitable: 'yes_no',
  month: 'month',
  paymentDate: 'payment_date',
  paymentAmount: 'payment_amount',
  paymentType: 'payment_type',
  paymentMethod: 'payment_method',
  paymentAccount: 'payment_account',
  constructionStatus: 'construction_status',
  propertyCategory: 'property_category',
  propertyType: 'property_type',
  bhkType: 'bhk',
  approvalStatus: 'approval_status',
  amenities: 'amenities',
  documentType: 'doc_type',
};

export const DEFAULTS = {
  country: '1',
  state: '1',
  currency: 'CAD',
  status: 'unbilled',
  statusLabel: 'Unbilled',
  debit: 'dr',
  hst: '13',
  paymentType: 'received',
  month: () => getCurrentMonthAndYear().month,
  year: () => getCurrentMonthAndYear().year,
};

export const VALIDATION_TYPE = {
  email: 'EMAIL',
};

export const RESERVATION_STATUS = {
  accepted: 'accepted',
  expired: 'expired',
  cancelled: 'cancelled',
  unbilled: 'unbilled',
  reconciled: 'reconciled',
};

export const TRANSACTION_STATUS = {
  unbilled: 'unbilled',
  invoiced: 'invoiced',
};

export const INVOICE_STATUS = {
  reconciled: 'reconciled',
  draft: 'draft',
  sent: 'sent',
  overdue: 'overdue',
};

export const SOURCE = {
  hospitable: 'hospitable',
  manual: 'manual',
};
